export default __webpack_public_path__ + "static/media/new-world.a4eb38b3.svg";